import type { ReactNode } from 'react';
import { Navigate } from 'react-router';
import { usePermissions } from '@/hooks/use-permissions';

interface PermissionGateProps {
    require?: string[];
    requireAny?: string[];
    requireRole?: string;
    hide?: boolean;
    redirectTo?: string;
    children: ReactNode;
}

export function PermissionGate({
    require,
    requireAny,
    requireRole,
    hide = false,
    redirectTo = '/',
    children,
}: PermissionGateProps) {
    const { hasAllPermissions, hasAnyPermission, hasRole, isPlatformAdmin } = usePermissions();

    if (isPlatformAdmin) {
        return <>{children}</>;
    }

    let authorized = true;

    if (require && require.length > 0) {
        authorized = authorized && hasAllPermissions(...require);
    }

    if (requireAny && requireAny.length > 0) {
        authorized = authorized && hasAnyPermission(...requireAny);
    }

    if (requireRole) {
        authorized = authorized && hasRole(requireRole);
    }

    if (!authorized) {
        if (hide) {
            return null;
        }
        return <Navigate to={redirectTo} replace />;
    }

    return <>{children}</>;
}
